import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { getBookingById, clearSelectedBooking } from '../../store/slices/bookingSlice';
import { AppDispatch } from '../../store';

export const useBookingDetail = (bookingId: number) => {
  const dispatch = useDispatch<AppDispatch>();
  const { selectedBooking, isLoading, error } = useSelector((state: RootState) => state.bookings);

  // Use organizationContext.selectedOrganizationId as primary source,
  // fall back to organizations.selectedOrganisation.id for consistency
  // with other hooks like usePayments
  const selectedOrganizationId = useSelector(
    (state: RootState) =>
      state.organizationContext.selectedOrganizationId ||
      state.organizations.selectedOrganisation?.id
  );

  // Use ref to track if initial fetch has been done
  const initialFetchDone = useRef(false);

  useEffect(() => {
    if (selectedOrganizationId && bookingId && !initialFetchDone.current) {
      dispatch(getBookingById({ organizationId: selectedOrganizationId, bookingId }));
      initialFetchDone.current = true;
    }

    return () => {
      dispatch(clearSelectedBooking());
    };
  }, [dispatch, selectedOrganizationId, bookingId]);

  return { booking: selectedBooking, isLoading, error };
};
